import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { VariantColor } from '@repo/toolkit/colors'

import { LocaleKeys } from '../../../locale/translation-types'
import { OtoIndividualTravelInfoStateEnum } from '../../types/enums/enrollment/oto-individual-travel-info-state.enum'

type OtoIndividualTravelInfoDisplay = { variant: VariantColor; color: string; label: LocaleKeys }

const otoIndividualTravelInfoDisplayMapping: Record<
  OtoIndividualTravelInfoStateEnum,
  OtoIndividualTravelInfoDisplay
> = {
  [OtoIndividualTravelInfoStateEnum.NOT_AVAILABLE]: {
    variant: 'grey',
    color: tailwindColors.grey.DEFAULT,
    label: 'oto.individual.placements.travel.info.not.available'
  },
  [OtoIndividualTravelInfoStateEnum.PERSON_MISSING]: {
    variant: 'danger',
    color: tailwindColors.red.DEFAULT,
    label: 'oto.individual.placements.transfer.person.missing'
  },
  [OtoIndividualTravelInfoStateEnum.COMPLETED]: {
    variant: 'success',
    color: tailwindColors.green.DEFAULT,
    label: 'oto.individual.placements.transfer.person.completed'
  }
}

/**
 * Colour and tooltip of the "Travel info" picto of an OTO Individual placement, from the state
 * the backend computed. Defaults to the grey "not available yet" picto.
 */
export function getOtoIndividualTravelInfoDisplay(
  state: OtoIndividualTravelInfoStateEnum
): OtoIndividualTravelInfoDisplay {
  return (
    otoIndividualTravelInfoDisplayMapping[state] ??
    otoIndividualTravelInfoDisplayMapping[OtoIndividualTravelInfoStateEnum.NOT_AVAILABLE]
  )
}
